import type { RGB } from "models-webgl2";
import { Vec2 } from "utils/math/vec2";
import { Webgl2 } from "../../../webgl2";
import { Webgl2Component } from "../../webgl2-component";

export type BrushComponentProps = {
  u_coords: Vec2;
  u_brushSize?: number;
};

type BrushComponentState = {
  u_brushSize: number;
  u_opacity: number;
  u_color: RGB;
};

export class BrushComponent extends Webgl2Component<BrushComponentProps, BrushComponentState> {
  constructor(initialState: BrushComponentState) {
    super(initialState);
  }

  public getRenderData(props: BrushComponentProps) {
    const material = Webgl2.materials.brush;
    material.setUniforms({
      u_size: this.transform.size.getAbs().getArray(),
      u_brushSize: props.u_brushSize ?? this.state.u_brushSize,
      u_opacity: this.state.u_opacity,
      u_color: this.state.u_color,
      u_coords: props.u_coords.getArray(),
    });
    return { material };
  }
}

export default BrushComponent;
